import { z } from 'zod';

export const SectorSchema = z.object({
	name: z
		.string()
		.min(1, 'Nome é obrigatório')
		.max(120, 'Nome deve ter no máximo 120 caracteres'),
	areaId: z.string().min(1, 'Área é obrigatória'),
	size: z.coerce
		.number()
		.min(0, 'Tamanho deve ser maior ou igual a 0'),
	plantingDate: z
		.string()
		.min(1, 'Data de plantio é obrigatória')
		.refine(v => !isNaN(new Date(v).getTime()), 'Data de plantio inválida'),
	lineSpacing: z.coerce
		.number()
		.min(0, 'Espaçamento entre linhas deve ser maior ou igual a 0'),
	plantSpacing: z.coerce
		.number()
		.min(0, 'Espaçamento entre plantas deve ser maior ou igual a 0'),
});

export type SectorSchemaType = z.infer<typeof SectorSchema>;
